import http from "./http-common";

class CompetenceService {

    async getCompetenceByCompany() {
        const response = await http.get("/competence/GetCompetenceByCompany");
        var data = response.data;
        return data;
    }

    async getEmployeeCompetence(employeeId) {
        const response = await http.get("/competence/GetEmployeeCompetence?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async getCompetenceCategoriesFromCompany() {
        const response = await http.get("/competence/GetCompetenceCategoriesFromCompany");
        var data = response.data;
        return data;
    }

    async saveEmployeeCompetence(employeeId, competenceList) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.post("/competence/saveEmployeeCompetence?employeeId=" + employeeId, JSON.stringify(competenceList));
        var data = response.data;
        return data;
    }

    

    async addCompetence(competenceCategoryId, name) {
        const response = await http.get("/competence/AddCompetence?competenceCategoryId=" + competenceCategoryId + "&name=" + name);
        var data = response.data;
        return data;
    }

    async updateCompetence(competenceId, name) {
        const response = await http.get("/competence/UpdateCompetence?competenceId=" + competenceId + "&name=" + name);
        var data = response.data;
        return data;
    }

    async deleteCompetence(competenceId) {
        const response = await http.get("/competence/DeleteCompetence?competenceId=" + competenceId);
        var data = response.data;
        return data;
    }

    async updateCompetenceCategory(competenceCategoryId, name) {
        const response = await http.get("/competence/UpdateCompetenceCategory?competenceCategoryId=" + competenceCategoryId + "&name=" + name);
        var data = response.data;
        return data;
    }

    async getEmployeeMultiskill(emploeeId, jobPositionId) {
        const response = await http.get("/competence/GetEmployeeMultiskill?emploeeId=" + emploeeId + "&jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async saveEmployeeMultiskill(employeeId, multiskillList) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.post("/competence/SaveEmployeeMultiskill?employeeId=" + employeeId, JSON.stringify(multiskillList));
        var data = response.data;
        return data;
    }

    async getMultiskillMatrix(multiskillJobPositionId,  emploeeId, employeeJobPositionId) {
        if (multiskillJobPositionId == null)
            multiskillJobPositionId = "";
        if (emploeeId == null)
            emploeeId = "0";
        if (employeeJobPositionId == null)
            employeeJobPositionId = "0";
        const response = await http.get("/competence/getMultiskillMatrix?multiskillJobPositionId=" + multiskillJobPositionId + "&emploeeId=" + emploeeId + "&employeeJobPositionId=" + employeeJobPositionId);
        var data = response.data;
        return data;
    }

    async getEducations() {
        const response = await http.get("/competence/getEducations");
        var data = response.data;
        return data;
    }

    async getEmployeesFromEducation(educationId) {
        const response = await http.get("/competence/GetEmployeesFromEducation?educationId=" + educationId);
        var data = response.data;
        return data;
    }

}

export default new CompetenceService();
